import { IGetAllCargosForTreinamentosCargosUseCase } from "../../../presentation/useCases/read/get_all_cargos_for_treinamentos_cargos_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { CargoTreinamentoCargo } from "../../models/cargo_treinamento_cargo";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetAllCargosForTreinamentosCargosUseCase
 */

export class GetAllCargosForTreinamentosCargosUseCase
  extends BasePaginatedUseCase<CargoTreinamentoCargo>
  implements IGetAllCargosForTreinamentosCargosUseCase {
  constructor(private readonly repository: IRhRepository) {
    super();
  }

  async getAllCargos(
    idTreinamento: number,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllCargoTreinamentoCargo(
      idTreinamento,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
